export default "https://cdn-static.gokick.com/assets/eeaee1442152ca0221916151b947444cbee5198d/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";